// extracted by mini-css-extract-plugin
module.exports = {"account__img":"containers_account__img__1bRvx","container_logo":"containers_container_logo__A4Mr0"};